module.exports = __webpack_public_path__ + "static/dolo-matrix-4c27effd29d8b555da06f8e44d8d3701.png";